import { cn } from "@/lib/utils"

interface NeonDividerProps {
  glow?: boolean
  className?: string
}

export function NeonDivider({ glow, className }: NeonDividerProps) {
  return (
    <div
      className={cn("h-0.5", className)}
      style={{
        background:
          "linear-gradient(90deg, oklch(0.85 0.28 85 / 0.3), oklch(0.85 0.28 85), oklch(0.8 0.3 145), oklch(0.8 0.3 145), oklch(0.85 0.28 85), oklch(0.85 0.28 85 / 0.3))",
        opacity: glow ? 1 : 0.4,
        filter: glow ? "brightness(1.2)" : "brightness(0.6)",
        boxShadow: glow
          ? "0 0 8px oklch(0.8 0.3 145 / 0.4), 0 0 20px oklch(0.85 0.28 85 / 0.15)"
          : "none",
      }}
    />
  )
}
